"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalHamburguerMenu_utils_exports = {};
__export(GlobalHamburguerMenu_utils_exports, {
  getLinkByRole: () => getLinkByRole,
  getMenuItemId: () => getMenuItemId
});
module.exports = __toCommonJS(GlobalHamburguerMenu_utils_exports);
var import_GlobalHamburguerMenu = require("./GlobalHamburguerMenu.constants");
var getLinkByRole = function getLinkByRole2(role) {
  if (role === void 0) {
    return (0, import_GlobalHamburguerMenu.getRoleLinks)("not-role-selected");
  }
  return (0, import_GlobalHamburguerMenu.getRoleLinks)(role);
};
var getMenuItemId = function getMenuItemId2(currentApp) {
  switch (currentApp) {
    case "explore":
    case "planning":
    case "livemode":
      return import_GlobalHamburguerMenu.EXPLORE_ID;
    case "assign":
      return import_GlobalHamburguerMenu.ASSIGN_ID;
    case "assess":
      return import_GlobalHamburguerMenu.ASSESS_ID;
    case "analyze":
      return import_GlobalHamburguerMenu.ANALYZE_ID;
    case "manage":
      return import_GlobalHamburguerMenu.MANAGE_ID;
    default:
      return null;
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  getLinkByRole,
  getMenuItemId
});
//# sourceMappingURL=GlobalHamburguerMenu.utils.js.map